import React from 'react';
import FormControlLabel from '@mui/material/FormControlLabel';
import MuiCheckbox from '@mui/material/Checkbox';

const Checkbox = (props) => {
  const { checked, label, name, onChange, children } = props;
  return (
    <FormControlLabel
      control={
        <MuiCheckbox checked={checked} onChange={onChange} name={name} />
      }
      label={children || label}
    />
  );
};

export default Checkbox;